import { Stack } from '@mui/material';
import Typography from '@mui/material/Typography';
import AutomockupCarousel from './AutomockupCarousel';

export default function AutoMockupLastStep({
  currentMockupLogo,
  // logoUrls,
  handleCarouselChange,
  isSubmitting,
}: {
  currentMockupLogo: string;
  // logoUrls: string[];
  handleCarouselChange: (logoUrl: string) => void;
  isSubmitting: boolean;
}) {
  return (
    <Stack my={4}>
      <AutomockupCarousel
        currentMockupLogo={currentMockupLogo}
        isSubmitting={isSubmitting}
        handleChange={handleCarouselChange}
        logos={[currentMockupLogo]}
        message={
          <Typography variant="subtitle1" mt={5}>
            <b>Fantastic! </b>
            We have your logo. Would you like to view our catalog with your branding?
          </Typography>
        }
      />
    </Stack>
  );
}
